export default __webpack_public_path__ + "static/media/img5.61268a5e.png";